import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#6A80EF",
        d: "M39.7692 37.8583H8.2747c-1.2491 0-2.2305-.9814-2.2305-2.2305V12.4307c0-1.2491.9814-2.2305 2.2305-2.2305h31.4945c1.2491 0 2.2305.9814 2.2305 2.2305v23.1971c0 1.2491-1.026 2.2305-2.2305 2.2305"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#32499E",
        d: "M22.9072 37.9033H8.2752C7.026 37.9033 6 36.8773 6 35.6282v-11.554h16.8625v13.8291z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#4357BA",
        d: "M39.7254 37.9027H22.9075V15.1963h19.0484v20.4759c0 1.2045-1.026 2.2305-2.2305 2.2305"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#4D5ECC",
        d: "M41.9559 15.9103H22.9075v-5.7101h16.8179c1.2491 0 2.2305.9814 2.2305 2.2305z"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#1D377F",
        d: "M17.7763 17.9621c0 .4461-.0893.8475-.2231 1.1598s-.3569.5799-.6245.803c-.2677.223-.5353.3569-.8476.4461s-.6246.1338-.9814.1338h-1.7844v-5.1747h1.6951c.3123 0 .6692.0446.9815.1338.3122.0892.6245.2231.8475.4015.2677.1784.4461.4461.6246.803.223.4015.3123.8029.3123 1.2937m-1.2045 0c0-.3123-.0446-.5354-.1338-.7138-.0893-.1784-.2231-.3569-.3569-.4461-.1338-.1338-.3123-.1784-.4907-.223s-.3569-.0893-.58-.0893h-.5799v3.0335h.5353c.2231 0 .4015-.0446.58-.0892s.3568-.1338.4907-.2677c.1338-.1338.2676-.2676.3568-.4461.1339-.223.1785-.4907.1785-.7583"
    }, "4")
], "AppDashboard", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
